<template>
  <div class="row table-sm mr-0 ml-0 p-0">
    <div class="row table-sm mr-0 ml-0 p-0 mb-3 width-100">
      <div
        class="
          col-7
          p-0
          align-self-center
          font-weight-bold
          d-flex
          align-items-center
          w-reset
          mb-sm-2
        "
      >
        <h5 class="d-inline mr-2 font-weight-bold">{{$t('message.procedural_list')}}</h5>
        <crm-refresh @c-click="refresh()"></crm-refresh>
        <div class="text-center d-flex sorddata ml-3">
          <el-input
            size="mini"
            :placeholder="$t('message.search')"
            prefix-icon="el-icon-search"
            v-model="filterForm.search"
            clearable
          ></el-input>
        </div>
      </div>
      <div
        class="
          col-5
          align-items-center align-self-center
          text-right
          pr-0
          d-flex
          justify-content-end
          w-reset
        "
      >
        <div class="btn excel_btn" v-loading.body="loadingData">
          <el-switch
            v-model="mode"
            active-value="stationary"
            inactive-value="ambulatory"
            :active-text="$t(`message.stationary`)"
            :inactive-text="$t(`message.ambulatory`)"
            v-can="['patientMedicine.ambulatory', 'patientMedicine.stationary']"
          />
        </div>
        <export-excel
          v-can="'patients.excel'"
          class="btn excel_btn"
          :data="ambulatory"
          :fields="excel_fields"
          @fetch="controlExcelData()"
          worksheet="Процедурный лист"
          name="Процедурный_лист.xls"
        >
          <el-button size="mini" icon="el-icon-document-delete"
            >Excel</el-button
          >
        </export-excel>
        <crm-column-settings
          :columns="columns"
          :modelName="'doctorCabinet'"
          @c-change="updateColumn"
        ></crm-column-settings>
      </div>
    </div>
    <table class="table table-bordered table-hover" v-loading="loadingData">
      <crm-pagination
        :pagination="pagination"
        @c-change="updatePagination"
      />
      <thead>
        <tr>
          <crm-th :column="columns.id" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.patient_id" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.day" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.partner_doctor_id" :sort="sort" @c-change="updateSort"/>
          <crm-th :sort="sort" :column="columns.settings" @c-change="updateSort"/>
        </tr>
        <tr>
          <th v-if="columns.id.show">
            <el-input
              clearable
              size="mini"
              class="id_input"
              v-model="filterForm.id"
              :placeholder="columns.id.title"
            ></el-input>
          </th>
          <th v-if="columns.patient_id.show">
            <el-input
              size="mini"
              v-model="filterForm.patient_id"
              :placeholder="columns.patient_id.title"
              clearable
            ></el-input>
          </th>
          <th v-if="columns.day.show">
            <el-date-picker
              v-model="filterForm.day"
              :placeholder="columns.day.title"
              size="mini"
              :format="'dd.MM.yyyy'"
              :value-format="'dd.MM.yyyy'"
            ></el-date-picker>
          </th>
          <th v-if="columns.partner_doctor_id.show">
            <el-select
              filterable
              clearable
              :placeholder="columns.partner_doctor_id.title"
              size="mini"
              v-model="filterForm.partner_doctor_id"
            >
              <el-option
                v-for="item in partner_doctors"
                :key="'partner_doctor' + item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </th>
          <th v-if="columns.settings.show"></th>
        </tr>
      </thead>

      <transition-group name="flip-list" tag="tbody">
        <tr v-if="mode === 'ambulatory'" v-for="o_service in ambulatory" :key="o_service.id">
          <td v-if="columns.id.show">{{ o_service.source.id + '-' + o_service.service.id }}</td>
          <td v-if="columns.patient_id.show">
            {{ o_service.source.patient.surname ? o_service.source.patient.surname : "" }}
            {{ o_service.source.patient.first_name }}
          </td>
          <td v-if="columns.day.show">{{ o_service.source.day }}</td>
          <td v-if="columns.partner_doctor_id.show">
            {{ o_service.source.partner_doctor ? o_service.source.partner_doctor.surname : "" }}
            {{ o_service.source.partner_doctor ? o_service.source.partner_doctor.name : "" }}
          </td>
          <td v-if="columns.settings.show" class="settings-td">
            <div class="za_btn">
              <el-button
                v-if="!button(o_service.id)"
                v-can="'patientMedicine.create'"
                @click="createOrderModal(o_service.id)"
                type="primary"
                icon="el-icon-edit"
                >{{ $t("message.create") }}</el-button
              >
            </div>
            <div class="za_btn">
              <el-button
                v-can="'patientMedicine.update'"
                v-if="button(o_service.id)"
                @click="edit(o_service)"
                type="success"
                icon="el-icon-edit"
                >{{ $t("message.update") }}</el-button
              >
              <el-button
                v-can="'patientMedicine.show'"
                v-if="button(o_service.id)"
                @click="showMedicine(o_service.patient_medicine.id)"
                type="primary"
                icon="el-icon-view"
              >{{ $t("message.show_0") }}</el-button
              >
            </div>
          </td>
        </tr>
        <tr v-if="mode === 'stationary'" v-for="h_service in stationary" :key="h_service.id">
          <td v-if="columns.id.show">{{ h_service.source.id + '-' + h_service.service.id }}</td>
          <td v-if="columns.patient_id.show">
            {{ h_service.source.patient.surname ? h_service.source.patient.surname : "" }}
            {{ h_service.source.patient.first_name }}
          </td>
          <td v-if="columns.day.show">{{ h_service.source.day }}</td>
          <td v-if="columns.condition_id.show">
            {{ h_service.source.condition ? h_service.source.condition.name : "" }}
          </td>
          <td v-if="columns.partner_doctor_id.show">
            {{ h_service.source.partner_doctor ? h_service.source.partner_doctor.surname : "" }}
            {{ h_service.source.partner_doctor ? h_service.source.partner_doctor.name : "" }}
          </td>
          <td v-if="columns.settings.show" class="settings-td">
            <div class="za_btn">
              <el-button
                v-if="!button(h_service.id)"
                @click="createHospitalModal(h_service.id)"
                type="primary"
                icon="el-icon-edit"
                >{{ $t("message.create") }}</el-button
              >
            </div>

            <div class="za_btn">
              <el-button
                v-if="button(h_service.id)"
                @click="edit(h_service)"
                type="seccess"
                icon="el-icon-edit"
                >{{ $t("message.update") }}</el-button
              >
              <el-button
                v-if="button(h_service.id)"
                @click="showMedicine(h_service.patient_medicine.id)"
                type="primary"
                icon="el-icon-view"
              >{{ $t("message.show_0") }}</el-button
              >
            </div>
          </td>
        </tr>
      </transition-group>
    </table>
    <el-drawer
      size="85%" :wrapperClosable="false"
      :visible.sync="drawer.create.status"
      :ref="drawer.create.name"
      @opened="drawerOpened(drawer.create.component)"
      @closed="drawerClosed(drawer.create.component)"
    >
      <crm-create
        :source="source"
        :type="mode"
        :ref="drawer.create.component"
        :drawer-name="drawer.create.name"
      />
    </el-drawer>
    <el-drawer
      size="85%" :wrapperClosable="false"
      :visible.sync="drawer.update.status"
      :ref="drawer.update.name"
      @opened="drawerOpened(drawer.update.component)"
      @closed="drawerClosed(drawer.update.component)"
    >
      <crm-update
        :selected="selectedModel"
        :type="mode"
        :ref="drawer.update.component"
        :drawer-name="drawer.update.name"
      >
      </crm-update>
    </el-drawer>
    <el-drawer
      size="95%" :wrapperClosable="false"
      :visible.sync="drawer.show.status"
      :ref="drawer.show.name"
      @opened="drawerOpened(drawer.show.component)"
      @closed="drawerClosed(drawer.show.component)"
    >
      <crm-show
        :selected="selectedModel"
        :ref="drawer.show.component"
        :drawer-name="drawer.show.name"
        @c-close="closeDrawer"
      />
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import list from "@/utils/mixins/list";
import drawer from "@/utils/mixins/drawer";
import CrmShow from "@/views/patientMedicineShow/components/crm-show.vue";
import _ from "lodash";
export default {
  mixins: [list, drawer],
  name: "PatientServiceList",
  components: {
    CrmShow,
    CrmCreate,
    CrmUpdate,
  },
  data() {
    return {
      drawerCreateCoculation: false,
      drawerUpdate: false,
      selectedModel: {},
      afterCreate: false,
      drawer: {
        create: {
          name: "create",
          status: false,
          component: "componentDrawerCreate",
        },
        update: {
          name: "update",
          status: false,
          component: "componentDrawerUpdate",
        },
        show: {
          name: "show",
          status: false,
          component: "componentDrawerShow",
        },
      },
      filterForm: {},
      reopenCreate: false,
      reopenUpdate: false,
      excel_data: [],
      excel_fields: {},
      loadingData: false,
      source: null,
      mode: 'ambulatory',
    };
  },
  computed: {
    ...mapGetters({
      ambulatory: "patientMedicine/order_list",
      stationary: "patientMedicine/hospital_list",
      columns: "doctorCabinet/columns",
      pagination: "doctorCabinet/pagination",
      filter: "doctorCabinet/filter",
      sort: "doctorCabinet/sort",
      conditions: "conditions/list",
      partner_doctors: "partnerDoctor/list",
      lists: "patientMedicine/patient_medicine",
      order_pagination: "patientMedicine/order_pagination",
      hospital_pagination: "patientMedicine/hospital_pagination",
    }),
    actions: function () {
      return ["edit", "delete"];
    },
    currentPagination() {
      if (this.mode === 'ambulatory') {
        return this.order_pagination;
      } else {
        return this.hospital_pagination;
      }
    },
  },
  watch: {
    currentPagination: {
      handler(newVal) {
        if (newVal) {
          this.updatePagination({ key: 'total', value: newVal.total });
          this.updatePagination({ key: 'per_page', value: newVal.per_page });
          this.updatePagination({ key: 'current_page', value: newVal.current_page });
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {},
  async mounted() {
    if (this.lists && this.lists.length === 0) await this.loadPatient();
    await this.controlExcelData();
    this.fetchNewData =  _.debounce(this.fetchData, 500);
    if (this.partner_doctors && this.partner_doctors.length === 0)
      await this.loadPartnerDoctors({ column: 'name', order: 'asc'});

    if (this.$can('patientMedicine.ambulatory')) {
      this.mode = 'ambulatory';
    } else if (this.$can('patientMedicine.stationary')) {
      this.mode = 'stationary';
    }
  },
  methods: {
    ...mapActions({
      updateList: "patientMedicine/patientListMedicine",
      showOrderModel: "orders/serviceShow",
      showHospitalModel: "hospitalizationServices/show",
      showPatientMedicine: "patientMedicine/patientShow",
      showMedicine: "patientMedicine/patientMedicineShowOrder",
      updateSort: "doctorCabinet/updateSort",
      updateFilter: "doctorCabinet/updateFilter",
      updateColumn: "doctorCabinet/updateColumn",
      updatePagination: "doctorCabinet/updatePagination",
      empty: "doctorCabinet/empty",
      refreshData: "doctorCabinet/refreshData",
      loadPartnerDoctors: "partnerDoctor/index",
      loadPatient: "patientMedicine/patientMedicineShow",
      loadConditions: "conditions/iventory",
    }),
    button(data) {
      return this.lists.filter((val) => val.origin_id == data).length
    },
    async fetchData() {
      const query = {
        ...this.filterForm,
        ...this.pagination,
        ...this.sort,
      };

      if (!this.loadingData) {
        this.loadingData = true;
        await this.loadPatient();
        await this.updateList(query)
          .then((res) => {
            this.loadingData = false;
          })
          .catch((err) => {
            this.loadingData = false;
          });
      }
    },
    refresh() {
      this.refreshData();
    },
    async show(id) {
      this.$router.push("/doctor-cabinet/conclusions/" + id);
    },
    async showMedicine(model) {
      this.selectedModel = model;
      this.drawer.show.status = true;
      this.$loadingCursor("wait");
      await this.showPatientMedicine(model)
        .then((res) => {
          this.$loadingCursor("default");
          this.drawerShow = true;
        })
        .catch((err) => {
          this.$loadingCursor("default");
        });
    },
    async createOrderModal(id) {
      this.$loadingCursor("wait");
      const query = { id: id, relation: true };
      this.showOrderModel(query)
        .then((res) => {
          this.drawer.create.status = true;
          this.source = res;
          this.$loadingCursor("default");
        })
        .catch((err) => {
          this.$loadingCursor("default");
        });
    },
    async createHospitalModal(id) {
      this.$loadingCursor("wait");
      this.showHospitalModel(id)
        .then((res) => {
          this.drawer.create.status = true;
          this.source = res;
          this.$loadingCursor("default");
        })
        .catch((err) => {
          this.$loadingCursor("default");
        });
    },
    edit(model) {
      this.selectedModel = model;
      this.drawer.update.status = true;
    },
    controlExcelData() {
      this.excel_fields = {};
      for (let key in this.columns) {
        if (this.columns.hasOwnProperty(key)) {
          let column = this.columns[key];
          if (column.show && column.column !== "settings") {
            switch (column.column) {
              case 'id':
                this.excel_fields[column.title] = {
                  callback: (o_service) => {
                    console.log(o_service)
                    return o_service.source.id + '-' + o_service.service.id
                  }
                };
                break;
              case 'patient':
                this.excel_fields[column.title] = {
                  field: "patient_name",
                };
                break;
              case 'service':
                this.excel_fields[column.title] = {
                  field: "service_name",
                };
                break;
              case 'service_type_name':
                this.excel_fields[column.title] = {
                  field: "service_type_name",
                };
                break;

              default:
                this.excel_fields[column.title] = column.column;
            }
          }
        }
      }
    },
    emptyModel() {
      this.empty();
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-wrap {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 16px;

  @media screen and (max-width: 1168px) {
    gap: 1rem;
    flex-wrap: wrap;
  }

  // filter-wrap__btn
  &__btn {
    outline: none;
    background: #fff;
    border: none;
    border-radius: 10px;
    padding: 6px 20px;
    color: #606266;
    font-weight: 600;
    font-size: 15px;
    transition: all 0.15s ease-in-out;

    &.active {
      color: #fff;
      background: #409eff;
    }

    &::first-letter {
      text-transform: uppercase;
    }

    &:hover {
      color: #fff;
      background: #66b1ff;
    }

    &:active {
      background: #3a8ee6;
    }
  }
}
.router_style {
  td {
    padding: 0 !important;
    margin: 0px !important;
    a {
      display: block;
      padding: 0.3rem;
      color: #303030;
      font-weight: 200 !important;
      font-size: 14px !important;
    }
  }
}
</style>